import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getSessionItem } from "./authSession";

const httpLink = createHttpLink({
  uri:
    process.env.NODE_ENV === "production"
      ? "/graphql"
      : "http://graphql-engine:8080/v1/graphql",
});

const authLink = setContext(async ({ operationName }, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = getSessionItem("accessToken");
  // return the headers to the context so httpLink can read them

  if (!token || operationName === "refreshToken") {
    return {
      headers,
    };
  }

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
